import { render, staticRenderFns } from "./UpDateStudent.vue?vue&type=template&id=d158260a&scoped=true&"
import script from "./UpDateStudent.vue?vue&type=script&lang=js&"
export * from "./UpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./UpDateStudent.vue?vue&type=style&index=0&id=d158260a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d158260a",
  null
  
)

export default component.exports